import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, TThunkApi } from 'store/store';
import * as manApi from 'api/ManApi';

const initialState = {
  id: null,
  managerId: null,
  codeName: null,
  appDesign: {
    tabs: [],
  },
  templates: {},
};

function loadHandler(
  state: typeof initialState,
  action: PayloadAction<{
    id: number;
    managerId: number;
    codeName: string;
    appDesign: any;
  }>
) {
  Object.assign(state, action.payload);
}

export const getAppInstanceFn = async (_: any, ThunkApi: TThunkApi) => {
  const store = ThunkApi.getState() as RootState;
  if (typeof store.appInstance.id === 'number') {
    return Promise.resolve();
  }

  return manApi
    .appInstanceGet(store)
    .then(({ data }) => {
      ThunkApi.dispatch(load(data));
      return Promise.resolve();
    })
    .catch((err) => {
      return ThunkApi.rejectWithValue(err) as any;
    });
};
const getAppInstance = createAsyncThunk(
  'appInstance/getAppInstance',
  getAppInstanceFn
);

const appInstanceSlice = createSlice({
  name: 'appInstance',
  initialState: initialState,
  reducers: {
    load: loadHandler,
  },
});

export const { load } = appInstanceSlice.actions;

export { getAppInstance };

export default appInstanceSlice.reducer;
